export default __webpack_public_path__ + "static/media/Skills.5f68a0df.png";